'use client';

import { useEffect } from 'react';

export default function HomeError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('[HomePage] Error:', error);
  }, [error]);

  return (
    <div className="p-4 w-full pt-2 bg-ds-surface-white min-h-screen">
      <div className="max-w-7xl mx-auto px-4 mt-20 flex flex-col items-center gap-4">
        <p className="ds-text-body-sm-semibold text-ds-text-default">
          Something went wrong loading the home page.
        </p>
        <button
          type="button"
          onClick={reset}
          className="ds-text-body-xs-medium text-ds-text-default border border-ds-border-subtlest rounded-md h-8 px-4 hover:bg-ds-gray-subtlest transition-colors"
        >
          Try again
        </button>
      </div>
    </div>
  );
}
